import React from 'react';
import { FAQAccordion } from '../components/faq/FAQAccordion';
import { PrivacySection } from '../components/faq/PrivacySection';
import { TimelineSection } from '../components/faq/TimelineSection';
export function FAQPage() {
  return <div className="w-full bg-gray-50" data-id="element-496">
      <div className="container mx-auto px-4 py-16" data-id="element-497">
        <h1 className="text-4xl font-bold text-center mb-4" data-id="element-498">
          Frequently Asked Questions
        </h1>
        <p className="text-lg text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-499">
          Find answers to common questions about the KS3 Maths Research Study.
        </p>
        <div className="max-w-3xl mx-auto space-y-12" data-id="element-500">
          <FAQAccordion data-id="element-501" />
          <PrivacySection data-id="element-502" />
          <TimelineSection data-id="element-503" />
        </div>
      </div>
    </div>;
}